export default __webpack_public_path__ + "static/media/silus.03ec34bc.png";